
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { File, Mail, MessageSquare, Phone } from "lucide-react";
import { CommunicationType } from './types';

interface CommunicationTabsProps {
  selectedTab: CommunicationType;
  setSelectedTab: (tab: CommunicationType) => void;
}

export const CommunicationTabs: React.FC<CommunicationTabsProps> = ({ 
  selectedTab, 
  setSelectedTab 
}) => {
  return (
    <Tabs value={selectedTab} onValueChange={(value) => setSelectedTab(value as CommunicationType)}>
      <TabsList className="grid grid-cols-4 w-full mb-6">
        <TabsTrigger value="all" className="flex items-center gap-2">
          <File className="h-4 w-4" />
          All
        </TabsTrigger>
        <TabsTrigger value="email" className="flex items-center gap-2">
          <Mail className="h-4 w-4" />
          Email
        </TabsTrigger>
        <TabsTrigger value="chat" className="flex items-center gap-2">
          <MessageSquare className="h-4 w-4" />
          Chat
        </TabsTrigger>
        <TabsTrigger value="call" className="flex items-center gap-2">
          <Phone className="h-4 w-4" />
          Calls
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};
